export const MATTER_CONTACT_CONNECTION_DEFAULT_VALUES = {
  id: "",
  contactName: "",
  addresses: [],
  emails: [],
  phones: [],
  faxes: [],
  tagConnections: [],
  type: "individual" as const,
};
